import {
  Autocomplete,
  TextField,
  LinearProgress,
  Typography,
} from "@mui/material";
import React, { Fragment } from "react";

const CommonCodeAutocomplete = ({
  label,
  options,
  inputValue,
  value,
  onInputChange,
  onValueChange,
  loading,
  onSelect,
}) => (
  <Autocomplete
    options={options}
    getOptionLabel={(option) => {
      if (typeof option === "string") return option;
      if (option && option.fulltext) return option.fulltext;
      if (option && option.code) return option.code;
      return "";
    }}
    inputValue={inputValue}
    value={value}
    onInputChange={onInputChange}
    onChange={(e, newValue) => {
      onValueChange(null);
      if (newValue) onSelect(newValue);
    }}
    loading={loading}
    autoComplete
    autoHighlight
    freeSolo={false}
    filterOptions={(options, state) => {
      const input = state.inputValue.replace(/\./g, "").toUpperCase();
      return options.filter((opt) => {
        const code = opt.code?.replace(/\./g, "").toUpperCase();
        const desc = opt.description?.toUpperCase();
        return code?.includes(input) || desc?.includes(input);
      });
    }}
    renderInput={(params) => (
      <TextField
        {...params}
        label={label}
        variant="outlined"
        size="small"
        margin="normal"
        slotProps={{
          textField: {
            InputProps: {
              ...params.InputProps,
              endAdornment: (
                <Fragment>
                  {loading ? (
                    <LinearProgress style={{ width: "100%" }} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </Fragment>
              ),
            },
          },
        }}
      />
    )}
    renderOption={(props, option) => (
      <li {...props}>
        <Typography>{`${option.code} - ${option.description}`}</Typography>
      </li>
    )}
    style={{ marginBottom: 16 }}
  />
);

export default CommonCodeAutocomplete;
